import { SELECTION_COLOR } from '../utils/constants.js';

/**
 * Overlay that draws the selection rectangle during drag operations.
 */
export class SelectionOverlay {
  render(ctx, state) {
    const start = state.get('selectionStart');
    const end = state.get('selectionEnd');
    if (!start || !end) return;

    const tileW = state.get('tileWidth');
    const tileH = state.get('tileHeight');

    const x1 = Math.min(start.x, end.x) * tileW;
    const y1 = Math.min(start.y, end.y) * tileH;
    const x2 = (Math.max(start.x, end.x) + 1) * tileW;
    const y2 = (Math.max(start.y, end.y) + 1) * tileH;

    ctx.fillStyle = SELECTION_COLOR;
    ctx.fillRect(x1, y1, x2 - x1, y2 - y1);

    ctx.strokeStyle = '#0078ff';
    ctx.lineWidth = 1;
    ctx.setLineDash([4, 4]);
    ctx.strokeRect(x1, y1, x2 - x1, y2 - y1);
    ctx.setLineDash([]);
  }
}
